import { render, staticRenderFns } from "./variables-sociodemograficas.vue?vue&type=template&id=3ba787f0&"
import script from "./variables-sociodemograficas.components.ts?vue&type=script&lang=ts&"
export * from "./variables-sociodemograficas.components.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports